import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { AddContentModalComponent } from "./AddContentModalComponent";

const AddContentModal = ModalManager.create(() => <AddContentModalComponent />);

export const useAddContentModal = () => useModal(AddContentModal);
